import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { computed, Injectable } from '@angular/core';
import { catchError, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { apiUrl } from '../../config/api-url';
import { ErrorhandlerService } from './errorhandler.service';
import { requestforEmulationPayload } from '../models/model';
import config from '../../../assets/config.json';
import { switchAdvisorService } from './switchAdvisorService';
@Injectable({
  providedIn: 'root',
})
export class HeaderService {
  private readonly apiUrl = environment.apiHost; // Use HTTPS and secure URLs
  private readonly endPoints = apiUrl;
  configData: any = config;
  hasBOB: Boolean = false;
  hasAD: Boolean = false;
  switchedAdvisor = computed(() => this._switchAdvisorService.switchedAdvisor());
  constructor(
    private _http: HttpClient,
    private _errorHandlerService: ErrorhandlerService,
    private _switchAdvisorService: switchAdvisorService,
  ) {}

  getNavigationHeader(body: requestforEmulationPayload): Observable<any> {
    return new Observable((observer) => {
      const httpHeaderOptions: { headers: HttpHeaders } = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          ...(this.switchedAdvisor() ? { AdvisorUserId: String(this.switchedAdvisor()?.advisorId) } : {}),
        }),
      };
      this._http
        .post<any>(this.apiUrl + this.endPoints.getHeaders, body, httpHeaderOptions)
        .pipe(catchError((error: HttpErrorResponse) => this._errorHandlerService.getErrorDetails(error)))
        .subscribe(
          (data) => {
            this.hasBOB = this.hasBookOfBusiness(data);
            this.hasAD = this.hasAccessDelegation(data);
            observer.next(data);
            observer.complete();
          },
          (error) => {
            observer.error(error);
          },
        );
    });
  }

  //get firelight id for form header item
  getAccordFirelightID(): Observable<any> {
    return new Observable((observer) => {
      const httpHeaderOptions: { headers: HttpHeaders } = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
      };
      this._http
        .post<any>(this.apiUrl + this.endPoints.getFireLightId, null, httpHeaderOptions)
        .pipe(catchError((error: HttpErrorResponse) => this._errorHandlerService.getErrorDetails(error)))
        .subscribe(
          (data) => {
            observer.next(data);
            observer.complete();
          },
          (error) => {
            observer.error(error);
          },
        );
    });
  }
  // Fetches the advisor list from the backend API

  getAdvisorList(body: requestforEmulationPayload): Observable<any> {
    return new Observable((observer) => {
      const httpHeaderOptions: { headers: HttpHeaders } = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
      };
      this._http
        .post<any>(this.apiUrl + this.endPoints.getAdvisorList, body, httpHeaderOptions)
        .pipe(catchError((error: HttpErrorResponse) => this._errorHandlerService.getErrorDetails(error)))
        .subscribe(
          (data) => {
            observer.next(data);
            observer.complete();
          },
          (error) => {
            observer.error(error);
          },
        );
    });
  }
  hasBOBAccess() {
    return this.hasBOB;
  }
  hasADAccess() {
    return this.hasAD;
  }
  hasBookOfBusiness(data: any): boolean {
    if (data && Array.isArray(data.header)) {
      return data.header.some(
        (item: { name: string }) => item.name?.trim().toLowerCase() === 'book of business'.toLowerCase(),
      );
    }
    return false;
  }
  hasAccessDelegation(data: any): boolean {
    if (data && Array.isArray(data.header)) {
      return !!data.header.find((item: any) => item.name === 'Delegation');
    }
    return false;
  }
}
